import axios from 'axios'
import config from '../../config'
import { TranslateDescriptionActionType } from '../action-types'
import { Dispatch } from 'redux'

const { apiUrl } = config

export const translateDescription =
    (
        text: string,
        selectedTranslation: 'en' | 'dk' | 'se' | 'no' | 'fi' | 'de'
    ) =>
    async (dispatch: Dispatch) => {
        const targetLanguage =
            selectedTranslation === 'dk'
                ? 'da'
                : selectedTranslation === 'se'
                ? 'sv'
                : selectedTranslation === 'de'
                ? 'de'
                : 'en'

        dispatch(translationDescriptionLoading())
        try {
            const endpoint = `${apiUrl}/v1/translate`

            const res = await axios.post(endpoint, {
                text,
                target_lang: targetLanguage,
            })
            const translatedText = res.data.data.text

            if (res.status !== 200) {
                return dispatch(
                    translationDescriptionError(
                        'Something went wrong. Please, try again later.'
                    )
                )
            } else if (res.status === 200) {
                dispatch(translationDescriptionSuccess())
                return translatedText
            }
        } catch (error) {
            dispatch(
                translationDescriptionError(
                    'Something went wrong. Please, try again later.'
                )
            )
        }
    }

export const translationDescriptionLoading = () => ({
    type: TranslateDescriptionActionType.TRANSLATION_LOADING,
})

export const translationDescriptionError = (error: string) => ({
    type: TranslateDescriptionActionType.TRANSLATION_ERROR,
    payload: error,
})

export const translationDescriptionSuccess = () => ({
    type: TranslateDescriptionActionType.TRANSLATION_SUCCESS,
})
